module.exports = __webpack_public_path__ + "img/circle-2.2.5c698540.svg";